import { render, staticRenderFns } from "./choiceYC.vue?vue&type=template&id=00f57088&scoped=true"
import script from "./choiceYC.vue?vue&type=script&lang=js"
export * from "./choiceYC.vue?vue&type=script&lang=js"
import style0 from "./choiceYC.vue?vue&type=style&index=0&id=00f57088&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f57088",
  null
  
)

export default component.exports